import { defineMessages } from 'react-intl';

import { Schema as sectionTitleSchema } from './schema';
import SectionTitleEdit from './SectionTitleEdit';
import SectionTitleView from './SectionTitleView';

import sectionTitleSVG from './icons/section-title.svg';

defineMessages({
  sectionTitle: {
    id: 'Section title',
    defaultMessage: 'Section title',
  },
});

const applyConfig = (config) => {
  config.blocks.blocksConfig.SectionTitleBlock = {
    id: 'SectionTitleBlock',
    title: 'Section title',
    group: 'text',
    icon: sectionTitleSVG,
    view: SectionTitleView,
    edit: SectionTitleEdit,
    blockSchema: sectionTitleSchema,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  };
  return config;
};

export default applyConfig;
